export default __webpack_public_path__ + "static/generator_b.5839d790b39e51192b93d77382c6b2a1.png";